/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preview_Deactivepreviewbtnlabel4Inputs */

const sv_preview_deactivepreviewbtnlabel4 = /** @type {(inputs: Preview_Deactivepreviewbtnlabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avsluta`)
};

const en_preview_deactivepreviewbtnlabel4 = /** @type {(inputs: Preview_Deactivepreviewbtnlabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deactivate preview mode`)
};

/**
* | output |
* | --- |
* | "Deactivate preview mode" |
*
* @param {Preview_Deactivepreviewbtnlabel4Inputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
const preview_deactivepreviewbtnlabel4 = /** @type {((inputs?: Preview_Deactivepreviewbtnlabel4Inputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preview_Deactivepreviewbtnlabel4Inputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_preview_deactivepreviewbtnlabel4(inputs)
	return en_preview_deactivepreviewbtnlabel4(inputs)
});
export { preview_deactivepreviewbtnlabel4 as "preview_deActivePreviewBtnLabel" }